
// javascript/controllers/mobile_menu_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() { }

  toggleOpen() {

    this.menuTarget.classList.toggle('hidden')
    // if (this.menuTarget.classList.contains('h-0')) {
    //   this.menuTarget.classList.remove('h-0')
    //   // this.menuTarget.classList.add('ma', 'ease-in')
    // } else {
    //   this.menuTarget.classList.add('h-0')
    //   // this.menuTarget.classList.add('translate-x-0', 'ease-out')
    // }
    // this.element.classList.toggle("hidden")
  }
}